import React from "react";
import { Check } from "lucide-react";

// Three sentences where a three-table commercial ledger used to be. The tables described someone
// else's prices (a gateway's MDR, an integration's one-time fee) beside ours, which is exactly the
// confusion a buyer reads as a hidden cost — and every figure in them belonged to a contract we
// are not a party to.
//
// Copy is CMS-owned (`pricing_page.other_charges`). No figure here is computed: these are quoted
// prices for things outside the plan, and the page must not imply it has priced them for you.
export default function PricingOtherCharges({ copy }) {
  const rows = Array.isArray(copy?.other_charges) ? copy.other_charges : [];
  if (!rows.length) return null;
  return (
    <section className="border-y border-line bg-surface" aria-labelledby="other-charges-h"
             data-testid="pricing-other-charges">
      <div className="mx-auto max-w-5xl px-5 py-12 sm:py-14">
        <h2 id="other-charges-h"
            className="font-heading font-bold text-2xl sm:text-[28px] text-ink tracking-tight">
          {copy.other_charges_heading}
        </h2>
        <ul className="mt-7 space-y-5">
          {rows.map((row) => (
            <li key={row.id} className="flex items-start gap-4" data-charge-row={row.id}>
              <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-primary/10">
                <Check className="h-4 w-4 text-primary" aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <h3 className="font-heading font-semibold text-ink text-[15px]">{row.title}</h3>
                <p className="mt-1 text-[14.5px] leading-relaxed text-ink-2">{row.body}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
